import Delegations from  'common/domain/models/delegations';

class vacationsAbsencesDelegations extends Delegations{
  constructor() {
    super();

  }
}

export default vacationsAbsencesDelegations;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/models/delegations.js